import { render, staticRenderFns } from "./CustomInfo.vue?vue&type=template&id=7c37d230&scoped=true"
import script from "./CustomInfo.vue?vue&type=script&lang=js"
export * from "./CustomInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomInfo.vue?vue&type=style&index=0&id=7c37d230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c37d230",
  null
  
)

export default component.exports